import React from "react";
//outsource
import { Row, Col, Input, InputNumber, Button, Checkbox } from "antd";
import { CloseOutlined } from "@ant-design/icons";
//components

const CardNote = ({ edit, data, handleChange, handleRemoveNote }) => {
  // -------------------------- VAR --------------------------
  const note = data?.note;
  const value = data?.value;
  const dataIndex = data?.dataIndex;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const handleNote = (e) => {
    const value = e?.target?.value;
    handleChange(dataIndex, "note", value);
  };

  const handleNumber = (value) => {
    handleChange(dataIndex, "value", value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[10, 10]} key={dataIndex} className="card-note">
      <Col span={17}>
        <Input
          disabled={!edit}
          defaultValue={note}
          onChange={handleNote}
          placeholder="Note"
        />
      </Col>
      <Col span={6}>
        <InputNumber
          min={0}
          prefix="$"
          disabled={!edit}
          placeholder="Amount"
          defaultValue={value}
          onChange={handleNumber}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
        />
      </Col>
      <Col span={1}>
        <Button
          type="text"
          shape="circle"
          disabled={!edit}
          onClick={() => handleRemoveNote(dataIndex)}
          icon={<CloseOutlined style={{ color: "red", fontSize: 20 }} />}
        />
      </Col>
    </Row>
  );
};

export default CardNote;
